import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f8cfef5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-container relative self-center grid grid-row-1 grid-col-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle rounded-full bg-System/app_secondary w-[32px] h-[32px]" }, null, -1))
const _hoisted_3 = { class: "props grid [grid-template-columns]: 'auto auto' gap-y-[0.4rem] gap-x-4 overflow-auto items-center" }
const _hoisted_4 = { class: "title truncate ellipsis h-full leading-4 gordita-400-12 text-3/4 text-Text/text_medium" }
const _hoisted_5 = ["data-testid", "data-value"]

import { ref } from 'vue';
import { IncrediTooltip } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';

type Entry = {
  title: string;
  value: string | null;
  noTooltip?: boolean;
  dataTestId: string;
  dataOriginalValue?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-header-info-props',
  props: {
    icon: null,
    entries: null
  },
  setup(__props: any) {

const valueHover = ref([]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-header-info-props flex flex-row flex-nowrap items-center px-4 gap-[12px]" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("i", {
          class: _normalizeClass(["icon absolute self-center text-System/app_secondary text-2xl opacity-100", __props.icon])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.entries?.filter(entry => !['', undefined, null].includes(entry.value)) || [], (prop, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(prop.title), 1),
            _createVNode(_unref(IncrediTooltip), {
              modelValue: valueHover.value[index],
              "onUpdate:modelValue": ($event: any) => ((valueHover.value[index]) = $event),
              class: "content-center h-full leading-4 overflow-auto",
              direction: "top-sticky-left",
              hover: !prop.noTooltip,
              delay: 200
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(prop.value), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "value truncate ellipsis leading-1 gordita-400-12 text-Text/text_high",
                  "data-testid": prop.dataTestId,
                  "data-value": prop.dataOriginalValue || prop.value
                }, _toDisplayString(prop.value), 9, _hoisted_5)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "hover"])
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})